import React from 'react';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { withLocalize } from "react-localize-redux";
import { Link } from 'react-router-dom';
import _ from 'lodash';
import moment from 'moment'
import { ActionIcon} from '@mantine/core';
import { IconSquareRoundedX } from '@tabler/icons';

import ContainerTranslation from "../partials/ContainerTranslation";
import AddButton from '../partials/AddButton';
import { TextAreaLabeled, TextAreaLabeledStatic } from '../input/TextAreaLabeled';


import {
	fetchConsultant,
	updateFieldConsultant,
	addFieldConsultant,
	removeFieldConsultant,
	getAutocompleteList,
	validate,
	updateFieldImageConsultant,
	downloadFieldImageConsultant,
	submit,
	draft,
	reject,
	expire,
	resetError
} from '../../actions/consultant';

import history from '../../history';
import { InputText } from '../input/InputText.tsx';
import { InputDate, InputYear } from '../input/InputDate';
import { InputNumber } from '../input/InputNumber.tsx';
import { SelectLabeled } from '../input/SelectLabeled.tsx';
import SelectAddField from '../input/SelectAddField';
import { CreatableSelectLabeled } from '../input/CreatableSelectLabeled.tsx';
import FormStepper from './FormStepper';



var updateTimeout = {}


class FormContainer extends React.Component {

	constructor(props) {
		super(props)
		this.state = {
			isValidatePopupOpen: false,
			isRejectPopupOpen: false,
			isSubmitPopupOpen: false,
			isExpiredPopupOpen: false,
		}
		this.props.fetchConsultant(this.props.match.params.id);
		this.props.getAutocompleteList(this.props.match.params.id);
		this.rejectReason = React.createRef();
		this.user = JSON.parse(localStorage.getItem("user"))
	}

	scrollTop() {
		window.scrollTo(0, 0);
	}

	toggleValidatePopup() {
		this.setState({ isRejectPopupOpen: false, isSubmitPopupOpen: false, isValidatePopupOpen: !this.state.isValidatePopupOpen, isExpiredPopupOpen : false });
	}

	toggleExpirePopup() {
		this.setState({ isRejectPopupOpen: false, isSubmitPopupOpen: false, isValidatePopupOpen: false, isExpiredPopupOpen: !this.state.isExpiredPopupOpen });
	}

	toggleRejectPopup() {
		this.setState({ isRejectPopupOpen: !this.state.isRejectPopupOpen, isSubmitPopupOpen: false, isValidatePopupOpen: false, isExpiredPopupOpen: false });
	}

	toggleSubmitPopup() {
		this.setState({ isRejectPopupOpen: false, isSubmitPopupOpen: !this.state.isSubmitPopupOpen, isValidatePopupOpen: false, isExpiredPopupOpen: false });
	}

	componentDidUpdate(prevProps) {
		if (Object.keys(prevProps.consultant).length !== 0 && Object.keys(this.props.consultant).length && prevProps.consultant.validationInformation.validationStatus !== this.props.consultant.validationInformation.validationStatus) {
			this.setState({ isRejectPopupOpen: false, isSubmitPopupOpen: false, isValidatePopupOpen: false });
		}
		

		if (this.props.message === 'Extract consultant') {
			history.push('/consultant/' + this.props.consultant._id);
		}

	}



	updateFieldImageConsultant(setter, files) {
		if (files === "") {
			this.props.updateFieldImageConsultant(setter, files, this.props.match.params.id)
		}
		if (files[0]) {
			const acceptedExtensions = [".png", ".jpg", ".jpeg", ".pdf"];
			const extension = files[0].name.substring(files[0].name.lastIndexOf("."));
			const isValidExtension = acceptedExtensions.find((m) => m === extension) != null;
			if (isValidExtension) {
				this.props.updateFieldImageConsultant(setter, files[0], this.props.match.params.id)
			} else {
			}
		}
	}

	updateFieldImageFactory(name, parent, index) {
		const _this = this
		function updateFieldImage(files) {
			const setter = { name: name, parent: parent, index: index };
			if (files === "") {
				_this.props.updateFieldImageConsultant(setter, files, _this.props.match.params.id)
			}
			if (files[0]) {
				const acceptedExtensions = [".png", ".jpg", ".jpeg", ".pdf"];
				const extension = files[0].name.substring(files[0].name.lastIndexOf("."));
				const isValidExtension = acceptedExtensions.find((m) => m === extension) != null;
				if (isValidExtension) {
					_this.props.updateFieldImageConsultant(setter, files[0], _this.props.match.params.id)
				} else {
				}
			}
		}

		return updateFieldImage
	}


	downloadFieldImageConsultant(getter) {

		this.props.downloadFieldImageConsultant(getter, this.props.match.params.id)

	}

	downloadFieldImageFactory(name,parent,index) {
		const _this = this
		function downloadFieldImage() {
			const getter = { name: name, parent: parent, index: index };
			_this.props.downloadFieldImageConsultant(getter, _this.props.match.params.id)

		}

		return downloadFieldImage
	}


	handleDocumentValidation(obj) {
		this.props.validate(this.props.match.params.id);
	}

	handleDocumentExpiration(obj) {
		this.props.expire(this.props.match.params.id);
	}

	handleDocumentSubmit(obj) {
		this.props.submit(this.props.match.params.id);	
	}

	handleDocumentDraft(obj) {
		this.props.draft(this.props.match.params.id);
	}

	handleDocumentReject(obj) {
		this.props.reject(this.props.match.params.id, this.rejectReason.current);
	}

	handleStepperClick(step) {
		var _this = this
		if (!_this.refs[step] && step === "expertise") step = "environnement";
		_this.refs[step].scrollIntoView({ behavior: 'smooth', block: 'center' });
	}

	handleInputChange(obj, isValid, withTimeout) {
		let _this = this
		if (withTimeout) {
			clearTimeout(updateTimeout[obj.name]);
			updateTimeout[obj.name] = setTimeout(function () {
				delete updateTimeout[obj.name]
				_this.props.updateFieldConsultant(obj, _this.props.match.params.id);
			}, 1000)
		} else {
			_this.props.updateFieldConsultant(obj, _this.props.match.params.id);
		}
	}


	handleDateChangeFactory(name, parent, index) {
		const _this = this
		function handleChangeDate(date) {

			if (date === null || date === undefined) {
				return _this.props.updateFieldConsultant({ name: name, parent: parent, index: index, value: null }, _this.props.match.params.id);
			}
			const parseddate = new Date(date)
			const formattedDate = parseddate !== "Invalid Date" ? moment(parseddate).format('DD/MM/YYYY') : null

			return _this.props.updateFieldConsultant({ name: name, parent: parent, index: index, value: formattedDate }, _this.props.match.params.id);
		}
		return handleChangeDate
	}


	handleYearChangeFactory(name, parent, index) {
		const _this = this
		function handleChangeYear(date) {

			if (date === null || date === undefined) {
				return _this.props.updateFieldConsultant({ name: name, parent: parent, index: index, value: null }, _this.props.match.params.id);
			}
			const parseddate = new Date(date)
			const formattedDate = parseddate !== "Invalid Date" ? moment(parseddate).format('YYYY') : null

			return _this.props.updateFieldConsultant({ name: name, parent: parent, index: index, value: formattedDate }, _this.props.match.params.id);
		}
		return handleChangeYear
	}

	string2Date(date) {
		return date ? new Date(Date.parse(moment(date, 'DD/MM/YYYY').toISOString())) : null
	}

	string2Year(date) {
		const date2return = date ? new Date(Date.parse(moment(date, 'YYYY').toISOString())) : null
		return date2return
	}

	handleBlurFactory(parent, index) {
		const handleBlur = (e) => {
			this.props.updateFieldConsultant({ name: e.target.name, value: e.target.value, parent: parent, index: index }, this.props.match.params.id);
		}
		return handleBlur
	}


	handleInputChangeFactory(parent, index) {

	const handleInputChange = (e) => {
		
	  this.props.updateFieldConsultant({name : e.name, value : e.value, parent : parent,  index : index}, this.props.match.params.id);
	}

		return handleInputChange

	}



	handleFieldsOnChangeFactory(parent,index) {

		function handleFieldOnChangeFactory(subfield){
			const handleFieldOnChange = (e) => {
					this.props.updateFieldConsultant({  name : subfield, 
													value : Array.isArray(e) ? e.map((ele)=>ele.value)  : e.value, 
													parent : parent,  
													index : index
												}, this.props.match.params.id);
			}
			return handleFieldOnChange.bind(this)
		}

		return handleFieldOnChangeFactory.bind(this)

  }



  handleInputChangeFactoryNew(parent,name,index) {

	const handleInputChange = (e) => {

	  this.props.updateFieldConsultant({  name : name, 
										  value : Array.isArray(e) ? e.map((ele)=>ele.value)  : e.value, 
										  parent : parent,  
										  index : index
										}, this.props.match.params.id);
	}

	return handleInputChange

  }



  handleRemoveFactory(parent, i) {

		const handleRemove = (e) => {
			this.props.removeFieldConsultant(i, parent, this.props.match.params.id);
		}
		return handleRemove
	}



	handleDomainExpChangeFactory(domain) {
		const _this = this;
		function handleExpChange(e) {


			let exp = _this.props.consultant.content.environnement["environnement-domain"];
			exp[domain] = e.target.value;

			const objToReturn = {
				index: undefined,
				name: "environnement-domain",
				parent: "environnement",
				value: exp
			};

			_this.props.updateFieldConsultant(objToReturn, _this.props.match.params.id);

		};
		return handleExpChange
	}


	handleContextExpChangeFactory(domain, context) {

		const _this = this;

		function handleExpChange(e) {
			let exp = _this.props.consultant.content.environnement["environnement-context"];
			exp[domain][context] = e.target.value;

			const objToReturn = {
				index: undefined,
				name: "environnement-context",
				parent: "environnement",
				value: exp
			};

			_this.props.updateFieldConsultant(objToReturn, _this.props.match.params.id);

		};
		return handleExpChange
	}


	duplicate(obj) {
		this.props.addFieldConsultant(this.props.consultant.fieldTemplate[obj], obj, this.props.match.params.id);
	}

	remove(obj, i) {
		this.props.removeFieldConsultant(i, obj, this.props.match.params.id);
	}

	renderSchool(schools) {
		let contents = []
		const _this = this
		_.each(schools, function (content, i) {
			const keySuffix = i + Date.now()
			if (i >= 0) {
				contents.push(<div key={'separator-' + keySuffix} className="separator">
					<div key={'school-' + keySuffix} style={{ float: "right" }}>
						{content['school-document'] !== "" && content['school-document'] !== undefined ? <><span className="delete-part"
							style={{ float: "none", marginLeft: "5px" }}
							onClick={(e) => _this.downloadFieldImageConsultant({ name: "school-document", parent: "school", index: i })}
							key={'schooldownload-' + keySuffix}
							id={'schooldownload-' + keySuffix}>
							<i className="fas fa-file-download"
								title={_this.props.translate('content.school.diploma.download')}
								style={{ color: '#ffffff' }}>
							</i>
						</span>
							<span className="delete-part"
								style={{ float: "none", marginLeft: "5px" }}
								onClick={(e) => _this.updateFieldImageConsultant({ name: "school-document", parent: "school", index: i }, "")}
								key={'schooldelete-' + keySuffix}
								id={'schooldelete-' + keySuffix}>
								<i className="fas fa-window-close"
									title={_this.props.translate('content.school.diploma.remove')}
									style={{ color: '#ffffff' }}>
								</i>
							</span>
						</> : null
						}
						<span className="delete-part" style={{ float: "none", marginLeft: "5px" }} key={'schooladd-' + keySuffix} id={'schooladd-' + keySuffix}>
							<label htmlFor={'diplomae' + i}><i className="fas fa-file-upload"
								title={_this.props.translate('content.school.diploma.upload')}
								style={{ color: '#ffffff' }} />
							</label>
							<input type="file"
								style={{ display: "none" }}
								onChange={(e) => _this.updateFieldImageConsultant({ name: "school-document", parent: "school", index: i }, e.target.files)}
								id={'diplomae' + i} />
						</span>
						<span style={{ width: "20px", display: "inline-block" }} />
						<span className="delete-part" style={{ float: "none", marginLeft: "5px" }} onClick={_this.remove.bind(_this, 'school', i)} key={'schoolremove-' + keySuffix} id={'schoolremove-' + keySuffix}><i className="fas fa-trash" style={{ color: '#ffffff' }}></i></span>
					</div>
				</div>)
			}
			contents.push(<div key={'school1-' + keySuffix} className={"formulaire-field text"}>
				<InputText
					onBlur={_this.handleBlurFactory('school', i)}
					value={content['school-name']}
					name={'school-name'}
					isRequired={true}
					label={{ title: _this.props.translate("content.school.school-name.title"), subtitle: _this.props.translate("content.school.school-name.sub") }}
				/>
			</div>)
			contents.push(<div key={'school2-' + keySuffix} className={"formulaire-field text"}>
				<InputYear
					locale={_this.props.translate('content.localisation')}
					onChange={_this.handleYearChangeFactory('school-year', 'school', i)}
					value={_this.string2Year(content['school-year'])}
					isRequired={true}
					label={_this.props.translate("content." + ['school'] + "." + ['school-year'] + ".title")}
				/>
			</div>)
			contents.push(<div key={'school3-' + keySuffix} className={"formulaire-field text"}>
				<InputText
					onBlur={_this.handleBlurFactory('school', i)}
					value={content['school-diplome']}
					name={'school-diplome'}
					isRequired={true}
					label={{ title: _this.props.translate("content.school.school-diplome.title"), subtitle: _this.props.translate("content.school.school-diplome.sub") }}
				/>
			</div>)
		})
		contents.push(<div key={'schoolduplicate'} className="duplicate" onClick={_this.duplicate.bind(_this, 'school')}>
			<AddButton />
		</div>)

		return (
			<div className={"formulaire wide"}>
				{contents}
			</div>
		)
	}

	renderTraining(formations) {
		let contents = []
		const _this = this
		_.each(formations, function (content, i) {
			const keySuffix = i + Date.now()
			if (i >= 0) {
				contents.push(<div key={'separator-' + keySuffix} className="separator">
					<div key={'training-' + keySuffix} style={{ float: "right" }}>
						{content['formation-document'] !== "" && content['formation-document'] !== undefined ? <><span className="delete-part"
							style={{ float: "none", marginLeft: "5px" }}
							onClick={(e) => _this.downloadFieldImageConsultant({ name: "formation-document", parent: "formation", index: i })}
							key={'formationdownload-' + keySuffix}
							id={'formationdownload-' + keySuffix}>
							<i className="fas fa-file-download"
								title={_this.props.translate('content.school.diploma.download')}
								style={{ color: '#ffffff' }}>
							</i>
						</span>
							<span className="delete-part"
								style={{ float: "none", marginLeft: "5px" }}
								onClick={(e) => _this.updateFieldImageConsultant({ name: "formation-document", parent: "formation", index: i }, "")}
								key={'formationdelete-' + keySuffix}
								id={'formationdelete-' + keySuffix}>
								<i className="fas fa-window-close"
									title={_this.props.translate('content.formation.formation-document.remove')}
									style={{ color: '#ffffff' }}>
								</i>
							</span>
						</> : null
						}
						<span className="delete-part" style={{ float: "none", marginLeft: "5px" }} key={'formationadd-' + keySuffix} id={'formationadd-' + keySuffix}>
							<label htmlFor={'formation-document' + i}><i className="fas fa-file-upload"
								title={_this.props.translate('content.school.diploma.upload')}
								style={{ color: '#ffffff' }} />
							</label>
							<input type="file"
								style={{ display: "none" }}
								onChange={(e) => _this.updateFieldImageConsultant({ name: "formation-document", parent: "formation", index: i }, e.target.files)}
								id={'formation-document' + i} />
						</span>
						<span style={{ width: "20px", display: "inline-block" }} />
						<span className="delete-part" style={{ float: "none", marginLeft: "5px" }} onClick={_this.remove.bind(_this, 'formation', i)} key={'formationremove-' + keySuffix} id={'formationremove-' + keySuffix}><i className="fas fa-trash" style={{ color: '#ffffff' }}></i></span>
					</div>
				</div>)
			}
			contents.push(<div key={'formation1-' + keySuffix} className={"formulaire-field text"}>
				<InputText
					onBlur={_this.handleBlurFactory('formation', i)}
					value={content['formation-name']}
					name={'formation-name'}
					isRequired={false}
					label={{ title: _this.props.translate("content.formation.formation-name.title"), subtitle: _this.props.translate("content.formation.formation-name.sub") }}
				/>
			</div>)
		})
		contents.push(<div key={'formationduplicate'} className="duplicate" onClick={_this.duplicate.bind(_this, 'formation')}>
			<AddButton />
		</div>)

		return (
			<div className={"formulaire wide"}>
				{contents}
			</div>
		)
	}

  renderLanguage(languages) {
	let contents = []
	  let _this = this

	  _.each(languages, function (content, i) {
		const keySuffix = i + Date.now()
		const languageLevel = { value: content['language-level'], label: _this.props.translate(`content.language.language-level.level.${content['language-level']}`) };
		const languageLevelOptions = _this.props.list.language.map((x) => { return { value: x, label: _this.props.translate(`content.language.language-level.level.${x}`) } });

		const handleFieldOnChangeFactory = _this.handleFieldsOnChangeFactory('language', i);

	  if (i >= 0) {
		  contents.push(<div key={'separator-' + keySuffix} className="separator">
			  <div key={'language-' + keySuffix} style={{ float: "right" }}>
				  {content['language-document'] ? <><span className="delete-part"
					  style={{ float: "none", marginLeft: "5px" }}
					  onClick={(e) => _this.downloadFieldImageConsultant({ name: "language-document", parent: "language", index: i })}
					  key={'languagedownload-' + keySuffix}
					  id={'languagedownload-' + keySuffix}>
					  <i className="fas fa-file-download"
						  title={_this.props.translate('content.school.diploma.download')}
						  style={{ color: '#ffffff' }}>
					  </i>
				  </span>
					  <span className="delete-part"
						  style={{ float: "none", marginLeft: "5px" }}
						  onClick={(e) => _this.updateFieldImageConsultant({ name: "language-document", parent: "language", index: i }, "")}
						  key={'languagedelete-' + keySuffix}
						  id={'languagedelete-' + keySuffix}>
						  <i className="fas fa-window-close"
							  title={_this.props.translate('content.language.language-document.remove')}
							  style={{ color: '#ffffff' }}>
						  </i>
					  </span>
				  </> : null
				  }
				  <span className="delete-part" style={{ float: "none", marginLeft: "5px" }} key={'languageadd-' + keySuffix} id={'languageadd-' + keySuffix}>
					  <label htmlFor={'language-document' + i}><i className="fas fa-file-upload"
						  title={_this.props.translate('content.school.diploma.upload')}
						  style={{ color: '#ffffff' }} />
					  </label>
					  <input type="file"
						  style={{ display: "none" }}
						  onChange={(e) => _this.updateFieldImageConsultant({ name: "language-document", parent: "language", index: i }, e.target.files)}
						  id={'language-document' + i} />
				  </span>
				  <span style={{ width: "20px", display: "inline-block" }} />
				  <span className="delete-part" style={{ float: "none", marginLeft: "5px" }} onClick={_this.remove.bind(_this, 'language', i)} key={'languageremove-' + keySuffix} id={'languageremove-' + keySuffix}><i className="fas fa-trash" style={{ color: '#ffffff' }}></i></span>
			  </div>
		  </div>)
	  }
	  contents.push(<div key={'language1-' + keySuffix} className={"formulaire-field text"}>
		<InputText
		  onBlur={_this.handleBlurFactory('language',i)}
		  value={content['language-name']}
		  name={'language-name'}
		  isRequired={false}
		  label={{title : _this.props.translate("content.language.language-name.title"), subtitle:_this.props.translate("content.language.language-name.sub")}}
		/>
	  </div>)
		contents.push(<div key={'language2-' + keySuffix} className={"formulaire-field text"}>
			<SelectLabeled
				label={{ title: _this.props.translate(`content.language.language-level.title`) }}
				value={languageLevel}
				onChange={handleFieldOnChangeFactory('language-level')}
				options={languageLevelOptions}
				isRequired={true}
			/>
	  </div>)
	  contents.push(<div key={'language3-' + keySuffix} className={"formulaire-field text"}>
		<InputText
		  onBlur={_this.handleBlurFactory('language',i)}
		  value={content['language-test']}
		  name={'language-test'}
		  label={{title : _this.props.translate("content.language.language-test.title"), subtitle:_this.props.translate("content.language.language-test.sub")}}
		/>
	  </div>)
	  contents.push(<div key={'language4-' + keySuffix} className={"formulaire-field text"}>
		<InputText
		  onBlur={_this.handleBlurFactory('language',i)}
		  value={content['language-result']}
		  name={'language-result'}
		  label={{title : _this.props.translate("content.language.language-result.title"), subtitle:_this.props.translate("content.language.language-result.sub")}}
		/>  
	  </div>)
	})
	contents.push(<div key={'languageduplicate'} className="duplicate" onClick={_this.duplicate.bind(_this, 'language')}>
	  <AddButton />
	</div>)

		return (
			<div className={"formulaire wide"}>
				{contents}
			</div>
		)
	}

	renderCertification(certifications) {
		let contents = []
		const _this = this
		_.each(certifications, function (content, i) {
			const keySuffix = i + Date.now()
			if (i >= 0) {
				contents.push(<div key={'separator-' + keySuffix} className="separator">
					<div key={'certification-' + keySuffix} style={{ float: "right" }}>
						{content['certification-document'] !== "" && content['certification-document'] !== undefined ? <><span className="delete-part"
							style={{ float: "none", marginLeft: "5px" }}
							onClick={(e) => _this.downloadFieldImageConsultant({ name: "certification-document", parent: "certification", index: i })}
							key={'certificationdownload-' + keySuffix}
							id={'certificationdownload-' + keySuffix}>
							<i className="fas fa-file-download"
								title={_this.props.translate('content.school.diploma.download')}
								style={{ color: '#ffffff' }}>
							</i>
						</span>
							<span className="delete-part"
								style={{ float: "none", marginLeft: "5px" }}
								onClick={(e) => _this.updateFieldImageConsultant({ name: "certification-document", parent: "certification", index: i }, "")}
								key={'certificationdelete-' + keySuffix}
								id={'certificationdelete-' + keySuffix}>
								<i className="fas fa-window-close"
									title={_this.props.translate('content.certification.certification-document.remove')}
									style={{ color: '#ffffff' }}>
								</i>
							</span>
						</> : null
						}
						<span className="delete-part" style={{ float: "none", marginLeft: "5px" }} key={'certificationadd-' + keySuffix} id={'certificationadd-' + keySuffix}>
							<label htmlFor={'certification-document' + i}><i className="fas fa-file-upload"
								title={_this.props.translate('content.school.diploma.upload')}
								style={{ color: '#ffffff' }} />
							</label>
							<input type="file"
								style={{ display: "none" }}
								onChange={(e) => _this.updateFieldImageConsultant({ name: "certification-document", parent: "certification", index: i }, e.target.files)}
								id={'certification-document' + i} />
						</span>
						<span style={{ width: "20px", display: "inline-block" }} />
						<span className="delete-part" style={{ float: "none", marginLeft: "5px" }} onClick={_this.remove.bind(_this, 'certification', i)} key={'certificationremove-' + keySuffix} id={'certificationremove-' + keySuffix}><i className="fas fa-trash" style={{ color: '#ffffff' }}></i></span>
					</div>
				</div>)
			}
			contents.push(<div key={'certification1-' + keySuffix} className={"formulaire-field text"}>
				<InputText
					onBlur={_this.handleBlurFactory('certification', i)}
					value={content['certification-name']}
					name={'certification-name'}
					isRequired={false}
					label={{ title: _this.props.translate("content.certification.certification-name.title"), subtitle: _this.props.translate("content.certification.certification-name.sub") }}
				/>
			</div>)
			contents.push(<div key={'certification2-' + keySuffix} className={"formulaire-field text"}>
				<InputText
					onBlur={_this.handleBlurFactory('certification', i)}
					value={content['certification-organisme']}
					name={'certification-organisme'}
					isRequired={false}
					label={{ title: _this.props.translate("content.certification.certification-organisme.title"), subtitle: _this.props.translate("content.certification.certification-organisme.sub") }}
				/>
			</div>)
			contents.push(<div key={'certification3-' + keySuffix} className={"formulaire-field text"}>
				<div className={"inline"}>
					<InputDate
						locale={_this.props.translate('content.localisation')}
						onChange={_this.handleDateChangeFactory('certification-start-date', 'certification', i)}
						value={_this.string2Date(content['certification-start-date'])}
						isRequired={false}
						label={_this.props.translate("content." + ['certification'] + "." + ['certification-start-date'] + ".title")}
					/>
				</div>
				<div className={"inline"} style={{ marginLeft: '20px' }}>
					<InputDate
						locale={_this.props.translate('content.localisation')}
						onChange={_this.handleDateChangeFactory('certification-end-date', 'certification', i)}
						value={_this.string2Date(content['certification-end-date'])}
						isRequired={false}
						label={_this.props.translate("content." + ['certification'] + "." + ['certification-end-date'] + ".title")}
					/>
				</div>
			</div>)
		})
		contents.push(<div key={'certificationduplicate'} className="duplicate" onClick={_this.duplicate.bind(_this, 'certification')}>
			<AddButton />
		</div>)

		return (
			<div className={"formulaire wide"}>
				{contents}
			</div>
		)
	}



	renderCreateAccreditationBodySkillsInput() {
		let options = []
		let _this = this


		_.each(_this.props.list['accreditation-body']['level-2'], function (missionArray, type) {
			missionArray.map(mission => {

				const typeLabel = _this.props.translate(['level-1'] + "." + type);
				const missionLabel = _this.props.translate(["level-2"] + "." + [type] + "." + [mission]);
				if (!missionLabel || !typeLabel) {
					return null;
				};

				let obj = {};


				obj['level-1'] = _this.props.list['accreditation-body']['level-1'].find(item => item === type);
				obj['level-2'] = mission;
				obj['level-3'] = "";
				obj['level-4'] = "";
				obj['experience'] = "";
				obj["expertise"] = "";
				obj["justification"] = "";


				obj['label'] = `${missionLabel} > ${typeLabel} `;

				return options.push(obj);

			});
		});

		_.each(_this.props.list['accreditation-body']['level-3'], function (appArray, key) {
			appArray.map(app => {

				const type = Object.entries(_this.props.list['accreditation-body']['level-2'])
					.map((values, key) => values.concat([key]))
					.filter(items => items.includes(key))
					.pop();


				const typeLabel = _this.props.translate(['level-1'] + "." + type);
				const missionLabel = _this.props.translate(["level-2"] + "." + [type] + "." + [key]);
				const appLabel = _this.props.translate(['level-3'] + "." + [key] + "." + [app]);

				if (!missionLabel || !typeLabel) {
					return null;
				};

				let obj = {};

				obj['intervention-type'] = type;
				obj['level-2'] = key;
				obj['level-3'] = app;
				obj['level-4'] = "";
				obj['experience'] = "";
				obj["expertise"] = "";
				obj["justification"] = "";


				obj['label'] = `${appLabel} > ${missionLabel} > ${typeLabel} `;

				return options.push(obj);

			});
		});


		return <SelectAddField
			noLabel={false}
			isRequired={true}
			placeholder={<ContainerTranslation id={['content'] + "." + ['placeholder'] + "." + ['search-skill']} />}
			id={_this.props.match.params.id}
			section={'content.accreditation-body'}
			parent={'accreditation-body'}
			options={options} />;

	}

	renderCreateOperationalSkillsInput() {
		var options = []
		var _this = this


		_.each(_this.props.list.operational['intervention-mission'], function (missionArray, type) {
			missionArray.map(mission => {

				const typeLabel = _this.props.translate(['intervention-type'] + "." + type);
				const missionLabel = _this.props.translate(["intervention-mission"] + "." + [type] + "." + [mission]);
				if (!missionLabel || !typeLabel) {
					return null;
				};

				let obj = {};


				obj['intervention-type'] = _this.props.list.operational['intervention-type'].find(item => item === type);
				obj['intervention-mission'] = mission;
				obj['intervention-application'] = "";
				obj['intervention-level-4'] = "";
				obj['intervention-experience'] = "";
				obj["expertise"] = "";
				obj["justification"] = "";


				obj['label'] = `${missionLabel} > ${typeLabel} `;

				return options.push(obj);

			});
		});

		_.each(_this.props.list.operational['intervention-application'], function (appArray, key) {
			appArray.map(app => {

				const type = Object.entries(_this.props.list.operational['intervention-mission'])
					.map((values, key) => values.concat([key]))
					.filter(items => items.includes(key))
					.pop();


				const typeLabel = _this.props.translate(['intervention-type'] + "." + type);
				const missionLabel = _this.props.translate(["intervention-mission"] + "." + [type] + "." + [key]);
				const appLabel = _this.props.translate(['intervention-application'] + "." + [key] + "." + [app]);

				if (!missionLabel || !typeLabel) {
					return null;
				};

				let obj = {};

				obj['intervention-type'] = type;
				obj['intervention-mission'] = key;
				obj['intervention-application'] = app;
				obj['intervention-level-4'] = "";
				obj['intervention-experience'] = "";
				obj["expertise"] = "";
				obj["justification"] = "";


				obj['label'] = `${appLabel} > ${missionLabel} > ${typeLabel} `;

				return options.push(obj);

			});
		});


		return <SelectAddField
			noLabel={false}
			isRequired={true}
			placeholder={<ContainerTranslation id={['content'] + "." + ['placeholder'] + "." + ['search-skill']} />}
			id={_this.props.match.params.id}
			section={'content.intervention-level'}
			parent={'intervention-level'}
			options={options} />;

	}


	renderCreateEngineeringSkillsInput() {
		var options = []
		var _this = this



		_.each(_this.props.list.engineering['engineering-specialization'], function (specializationArray, key) {
			specializationArray.map(specializationName => {
				var obj = {};
				obj['engineering-skill'] = key;
				obj['engineering-specialization'] = specializationName;
				obj['engineering-experience'] = "";
				const skillLabel = _this.props.translate(['engineering-skill'] + "." + key);
				const specializationLabel = _this.props.translate(['engineering-specialization'] + "." + [key] + "." + [specializationName]);
				obj['label'] = `${specializationLabel} > ${skillLabel}`;
				// obj['label'] = `${specializationName} > ${key}`;

				if (skillLabel && specializationLabel) {
					return options.push(obj);
				};
				return null;

			});
		});

		return <SelectAddField
			noLabel={false}
			isRequired={true}
			id={this.props.match.params.id}
			placeholder={<ContainerTranslation id={['content'] + "." + ['placeholder'] + "." + ['search-skill']} />}
			section={'content.engineering'}
			parent={'engineering'}
			options={options} />;

	}

  renderCreateTechnicalSkillsInput() {
	var options = []
	var arr = []
	var _this = this

		_.each(_this.props.list.technical['domain-speciality'], function (specialityArray, competence) {
			specialityArray.map(speciality => {
				var obj = {};
				_.each(_this.props.list.technical['domain-competence'], function (competenceArray) {
					if (competenceArray.find(item => item === competence)) {
						const competenceLabel = _this.props.translate(['domain-competence'] + "." + competence);
						const specialityLabel = _this.props.translate(["domain-speciality"] + "." + [competence] + "." + [speciality]);

						obj['domain-speciality'] = speciality;
						obj['domain-competence'] = competence
						obj['label'] = `${specialityLabel} > ${competenceLabel} `;
						return options.push(obj);
					}
				});
				return null;
			});
		});

		_.each(_this.props.list.technical['domain-specificity'], function (specificityArr, key) {
			specificityArr.map(specificityName => {
				var obj = {};
				var competenceName;
				_.each(_this.props.list.technical['domain-speciality'], function (specialityArray, specialitykey) {
					if (specialityArray.filter(item => item === key).length !== 0) {
						return competenceName = specialitykey;
					}
				})
				arr.push(specificityName)
				obj['domain-specificity'] = specificityName;
				obj['domain-speciality'] = key;
				obj['domain-experience'] = "";
				obj['domain-competence'] = competenceName;
				const competenceLabel = _this.props.translate(['domain-competence'] + "." + competenceName);
				const specialityLabel = _this.props.translate(['domain-speciality'] + "." + [competenceName] + "." + [key]);
				const specificityLabel = _this.props.translate(['domain-specificity'] + "." + [key] + "." + [specificityName]);
				obj['label'] = `${specificityLabel} > ${specialityLabel} > ${competenceLabel} `;
				// obj['label'] = `${specificityName} > ${key} > ${competenceName}`;
				return options.push(obj);
			});
		});

		return <SelectAddField
			noLabel={false}
			isRequired={true}
			id={this.props.match.params.id}
			placeholder={<ContainerTranslation id={['content'] + "." + ['placeholder'] + "." + ['search-skill']} />}
			section={'content.environnement-domain'}
			parent={'expertise'}
			options={options} />;
	}



	renderContexts(contexts) {
		let contents = []
		let subcontents = []
		let _this = this

		const list = _this.props.consultant.content.environnement["environnement-context"][contexts]
		Object.keys(list).forEach((key) => {
			const value = list[key];
			subcontents.push(
				<div key={'context1-' + key} style={{ backgroundColor: this.feedBackEnvironnement(value) }} className={"formulaire-field tab"} >
					<ContainerTranslation key={'context2-' + key} id={['context'] + "." + [key]} />
					<div key={'context3-' + key} className={"inline"} style={{ width: '90px', marginTop: '20px', display: 'block' }}>
						<InputNumber
							onBlur={_this.handleContextExpChangeFactory(contexts, key)}
							value={value}
							name={'environnement-experience'}
							isRequired={false}
							label={{ title: _this.props.translate("content.environnement.environnement-experience.title") }}
							suffix={_this.props.translate('years')}
						/>
					</div>
				</div>
			)
		});

		contents =
			<div>
				<div className={"formulaire-field tabs"} style={{ marginBottom: '22px' }}>
					{subcontents}
				</div>
			</div>

		return (
			<div>
				{contents}
			</div>
		)
	}

	feedBackEnvironnement(value) {
		if (value > 0) {
			return ('#52c1d0')
		} else {
			return ('#989DA3')
		}
	}

	renderImplications() {

		const implicationBusiness = this.props.consultant.content['implication'] && this.props.consultant.content['implication']['Business'] ?
			this.props.consultant.content['implication']['Business'].map((ele) => {
				return { value: ele, label: this.props.translate(`implication.Business.${ele}`) }
			}) : [];

		const implicationInnovation = this.props.consultant.content['implication'] && this.props.consultant.content['implication']['Innovation'] ?
			this.props.consultant.content['implication']['Innovation'].map((ele) => {
				return { value: ele, label: this.props.translate(`implication.Innovation.${ele}`) }
			}) : [];

		const implicationManagement = this.props.consultant.content['implication'] && this.props.consultant.content['implication']['Management'] ?
			this.props.consultant.content['implication']['Management'].map((ele) => {
				return { value: ele, label: this.props.translate(`implication.Management.${ele}`) }
			}) : [];

		const implicationTraining = this.props.consultant.content['implication'] && this.props.consultant.content['implication']['Training'] ?
			this.props.consultant.content['implication']['Training'].map((ele) => {
				return { value: ele, label: this.props.translate(`implication.Training.${ele}`) }
			}) : [];


		return (
			<div className={"formulaire wide"}>
				<div className={"formulaire-field select"}>
					<CreatableSelectLabeled
						label={{ title: this.props.translate('content.implication.Business.title') }}
						onChange={this.handleInputChangeFactoryNew('implication', 'Business')}
						value={implicationBusiness}
						options={this.props.list.implications.Business.map((ele) => { return { value: ele, label: this.props.translate(`implication.Business.${ele}`) } })}
						multi={true}
					/>
				</div>
				<div className={"formulaire-field select"}>
					<CreatableSelectLabeled
						label={{ title: this.props.translate('content.implication.Innovation.title') }}
						onChange={this.handleInputChangeFactoryNew('implication', 'Innovation')}
						value={implicationInnovation}
						options={this.props.list.implications.Innovation.map((ele) => { return { value: ele, label: this.props.translate(`implication.Innovation.${ele}`) } })}
						multi={true}
					/>
				</div>
				<div className={"formulaire-field select"}>
					<CreatableSelectLabeled
						label={{ title: this.props.translate('content.implication.Management.title') }}
						onChange={this.handleInputChangeFactoryNew('implication', 'Management')}
						value={implicationManagement}
						options={this.props.list.implications.Management.map((ele) => { return { value: ele, label: this.props.translate(`implication.Management.${ele}`) } })}
						multi={true}
					/>
				</div>
				<div className={"formulaire-field select"}>
					<CreatableSelectLabeled
						label={{ title: this.props.translate('content.implication.Training.title') }}
						onChange={this.handleInputChangeFactoryNew('implication', 'Training')}
						value={implicationTraining}
						options={this.props.list.implications.Training.map((ele) => { return { value: ele, label: this.props.translate(`implication.Training.${ele}`) } })}
						multi={true}
					/>
				</div>
			</div>
		);

	}

	renderValidate(route) {

		if (!localStorage.user || !this.props.consultant.authorization.validate) {
			return null;
		}

		if (this.props.consultant.progression.globalPercentage !== 100 ||
			this.props.consultant.validationInformation.validationStatus === "document_validation_status_validated" ||
			this.props.consultant.validationInformation.validationStatus === "document_validation_status_rejected") {
			return (
				<button className="view-btn disabled" onClick={(event) => event.preventDefault()}>
					{this.props.translate("validation.confirmation-button.validated")}
				</button>
			)
		}

		if (this.props.consultant.progression.globalPercentage === 100 && this.state.isValidatePopupOpen === false) {
            return (
                <button className="view-btn" onClick={() => { this.toggleValidatePopup() }} >
                    {this.props.translate("validation.confirmation-button.validated")}
                </button>
            )
		}

		if (this.props.consultant.progression.globalPercentage === 100 && this.state.isValidatePopupOpen) {
			return (
				<div className="full-screen">
					<div className="popup popup-small">
						<div style={{ position: "absolute", top: -18, right: -18 }}>
							<ActionIcon variant="filled" radius="xl" size="xl" color="red">
								<IconSquareRoundedX onClick={() => this.toggleValidatePopup()} style={{ width: '70%', height: '70%' }} />
							</ActionIcon>
						</div>
						<div>
							<div className="popup-message">
								{this.props.translate("validation.confirmation-warning.validated")}
							</div>
							<div className="btn-dashboard centered">
								<button className="primary-btn" onClick={() => { this.handleDocumentValidation(); window.location.href = route; }} >
									{this.props.translate("validation.confirmation-button.validated")}
								</button>
							</div>
						</div>
					</div>
				</div>
			)
		}


	}

	renderExpire(route) {

		if (!localStorage.user || !this.props.consultant.authorization.expire) {
			return null;
		}

		if (this.props.consultant.validationInformation.validationStatus !== "document_validation_status_validated") {
			return (
				<button className="view-btn disabled" onClick={(event) => event.preventDefault()}>
					{this.props.translate("validation.confirmation-button.expired")}
				</button>
			)
		}


		if (this.state.isExpiredPopupOpen) {
			return (
				<div className="full-screen">
					<div className="popup popup-small">
						<div style={{ position: "absolute", top: -18, right: -18 }}>
							<ActionIcon variant="filled" radius="xl" size="xl" color="red">
								<IconSquareRoundedX onClick={() => this.toggleExpirePopup()} style={{ width: '70%', height: '70%' }} />
							</ActionIcon>
						</div>
						<div>
							<div className="popup-message">
								{this.props.translate("validation.confirmation-warning.expired")}
							</div>
							<div className="btn-dashboard centered">
								<button className="primary-btn" onClick={() => { this.handleDocumentExpiration(); window.location.href = route; }} >
									{this.props.translate("validation.confirmation-button.expired")}
								</button>
							</div>
						</div>
					</div>
				</div>
			)
		}

        if (this.state.isValidatePopupOpen === false) {
            return (
                <button className="view-btn" onClick={() => { this.toggleExpirePopup() }} >
                    {this.props.translate("validation.confirmation-button.expired")}
                </button>
            )

        }




	}



	renderReject(route) {

		if (!localStorage.user || !this.props.consultant.authorization.validate) {
			return null;
		}

		if (this.props.consultant.progression.globalPercentage !== 100 ||
			this.props.consultant.validationInformation.validationStatus !== "document_validation_status_submitted") {
			return (
				<button className="view-btn disabled" onClick={(event) => event.preventDefault()}>
					{this.props.translate("validation.confirmation-button.rejected")}
				</button>
			)
		}

		if (this.props.consultant.progression.globalPercentage === 100 && this.state.isRejectPopupOpen === false) {
			return (
                <button className="view-btn" onClick={() => { this.toggleRejectPopup() }} >
                    {this.props.translate("validation.confirmation-button.rejected")}
                </button>
			)

		}

		//this.handleDocumentReject(); window.location.href = route;
		if (this.props.consultant.progression.globalPercentage === 100 && this.state.isRejectPopupOpen) {
			return (
				<div className="full-screen">
					<div className="popup popup-large">
						<div style={{ position: "absolute", top: -18, right: -18 }}>
							<ActionIcon variant="filled" radius="xl" size="xl" color="red">
								<IconSquareRoundedX onClick={() => this.toggleRejectPopup()} style={{ width: '70%', height: '70%' }} />
							</ActionIcon>
						</div>
						<div>
							<div className="popup-message">
								{this.props.translate("validation.confirmation-warning.rejected")}
							</div>
							<div className="margin">
								<TextAreaLabeledStatic
									onChange={(event) => {
										let { name, value } = event.target;
										this.rejectReason.current = value
									}}
									name={'rejectReason'}
									value={this.rejectReason.current}
									isRequired={false}
									label={{ title: 'reject reason' }}
									placeholder={""}
									maxLength={1000}
									height={'100px'}
									/>
							</div>
							<div className="btn-dashboard centered">
								<button className="primary-btn" onClick={() => { this.handleDocumentReject(); }} >
									{this.props.translate("validation.confirmation-button.rejected")}
								</button>
							</div>
						</div>
					</div>
				</div>
			)
		}


	}



	renderSubmit(route) {

		if (!localStorage.user || !this.props.consultant.authorization.write) {
			return null;
		}

		if (this.props.consultant.progression.globalPercentage !== 100 || this.props.consultant.validationInformation.validationStatus !== "document_validation_status_draft") {
			return (
				<button className="view-btn disabled" onClick={(event) => event.preventDefault()}>
					{this.props.translate("validation.confirmation-button.submitted")}
				</button>
			)
		}

		if (this.props.consultant.progression.globalPercentage === 100 && this.state.isSubmitPopupOpen === false) {
            return (
                <button className="view-btn" onClick={() => { this.toggleSubmitPopup() }} >
                    {this.props.translate("validation.confirmation-button.submitted")}
                </button>
            )
		}

		if (this.props.consultant.progression.globalPercentage === 100 && this.state.isSubmitPopupOpen) {
			return (
				<div className="full-screen">
					<div className="popup popup-small">
						<div style={{ position: "absolute", top: -18, right: -18 }}>
							<ActionIcon variant="filled" radius="xl" size="xl" color="red">
								<IconSquareRoundedX onClick={() => this.toggleSubmitPopup()} style={{ width: '70%', height: '70%' }} />
							</ActionIcon>
						</div>
						<div>
							<div className="popup-message">
								{this.props.translate("validation.confirmation-warning.submitted")}
							</div>
							<div className="btn-dashboard centered">
								<button className="primary-btn" onClick={() => { this.handleDocumentSubmit(); }} >
									{this.props.translate("validation.confirmation-button.submitted")}
								</button>
							</div>
						</div>
					</div>
				</div>
			)
		}


	}

	renderDraft() {

		if (!localStorage.user || !this.props.consultant.authorization.write) {
			return null;
		}


		if (this.props.error === "only document set to draft can be edited") {
			return (

				<div className="full-screen">
					<div className="popup popup-small">
						<div style={{ position: "absolute", top: -18, right: -18 }}>
							<ActionIcon variant="filled" radius="xl" size="xl" color="red">
								<IconSquareRoundedX onClick={() => this.props.resetError()} style={{ width: '70%', height: '70%' }} />
							</ActionIcon>
						</div>
						<div>
							<div className="popup-message">
								{this.props.translate("validation.confirmation-warning.drafted")}
							</div>
							<div className="btn-dashboard centered">
								<button className="primary-btn" onClick={() => { this.handleDocumentDraft(); }} >
									{this.props.translate("validation.confirmation-button.drafted")}
								</button>
							</div>
						</div>
					</div>
				</div>

			)
		}


	}


	getTitle(title) {

		if (!title || title === "") {
			return ""
		}

		let fulltitle = ""
		if (title["title1"] === "") {
			return fulltitle
		}
		fulltitle = fulltitle + this.props.translate(title["title1"])

		if (title["title2"] !== "") {
			fulltitle = fulltitle + " > " + this.props.translate(title["title2"])
		}

		if (title["experience"]) {
			fulltitle = fulltitle + " > " + title["experience"]
		}

		return fulltitle

	}



	render() {


		if (Object.keys(this.props.consultant).length === 0 || Object.keys(this.props.list).length === 0) {
			return null
		}


		const route = "/consultant/" + this.props.match.params.id;


		let name = <ContainerTranslation id={"Page." + ['ConsultantForm'] + "." + ['Admin-profile']} />;
		let subname = <ContainerTranslation id={"Page." + ['ConsultantForm'] + "." + ['Admin-subName']} />;

		if (localStorage.user) {
			const userClient = JSON.parse(localStorage.user);
			if (userClient.consultant && userClient.consultant._id === this.props.match.params.id) {
				name = <ContainerTranslation id={"Page." + ['ConsultantForm'] + "." + ['User-profile']} />;
				subname = <ContainerTranslation id={"Page." + ['ConsultantForm'] + "." + ['User-subName']} />;
			}
		}

		if (!(this.props.consultant.validationInformation.validationStatus === "document_validation_status_initialized" ||
			this.props.consultant.validationInformation.validationStatus === "document_validation_status_draft")) {
			subname = "This document is validated or about to be validated. Modified document need to be resubmit for validation"
		}

		let classRailway = ""
		let classEnergy = ""
		//ENVIRONNEMENT
		if (this.props.consultant.content['environnement'] && this.props.consultant.content['environnement']['environnement-domain']) {
			const environnementToTest = _.map(this.props.consultant.content['environnement']['environnement-domain'], function (domain) {
				return domain ? domain.name : ""
			});
			if (environnementToTest.indexOf('Railway') !== -1) {
				classRailway = " selected";
			}
			if (environnementToTest.indexOf('Energy') !== -1) {
				classEnergy = " selected";
			}
		}


		let valueExpEnergy = this.props.consultant.content.environnement['environnement-domain'].Energy
		let valueExpRailway = this.props.consultant.content.environnement['environnement-domain'].Railway

		let consultantTitle = this.getTitle(this.props.consultant.title)
		if (this.props.consultant.content["information-consultant"]["custom-title"] && this.props.consultant.content["information-consultant"]["custom-title"] !== "") {
			consultantTitle = this.props.consultant.content["information-consultant"]["custom-title"]
		}


		return (
			<div className="formulaires">

				<div style={{
					top: 99,
					position: "sticky",
					padding: 20,
					zIndex: 99,
					backgroundColor: "white",
					borderBottomLeftRadius: 10,
					borderBottomRightRadius: 10,
					border: "solid 1px #E2E3E3"
				}}>
					<FormStepper translate={this.props.translate} progression={this.props.consultant.progression.globalPercentage} categoryProgression={this.props.consultant.progression.completionPerCategory} onClick={this.handleStepperClick.bind(this)}></FormStepper>
				</div>
				<div>
					<div className="formulaires-header">
						<h2>{name}</h2>
						<p style={{ margin: 0, textAlign: 'center' }}>{subname}</p>
						<span className="link-back"><Link to={route}><i className="fas fa-arrow-left" style={{ color: "#E30119", marginRight: "10px" }}></i><ContainerTranslation id={"nav.Back"} /></Link></span>
					</div>
					{this.renderDraft()}


					{/*Title*/}
					<div className={"formulaire-section"}>
						<div className="formulaire-header" ref={"school"}>
							<ContainerTranslation id={"content.information.role.title"} tag="h2" />
						</div>
						<div className={"formulaire-field text"}>
							<InputText
								onBlur={this.handleBlurFactory('information-consultant')}
								value={consultantTitle}
								name={'custom-title'}
								isRequired={false} />
						</div>
					</div>

					{/*SCHOOL*/}
					<div className="formulaire-section">
						<div className="formulaire-header" ref={"school"}>
							<ContainerTranslation id={"content." + ['school'] + ".title"} tag="h2" />
							<p className="info">{"The field marked with"}<span>*</span> are required</p>
						</div>

						{this.renderSchool(this.props.consultant.content.school)}

					</div>


					{/*TRAINING*/}

					<div className="formulaire-section">

						<div className="formulaire-header">
							<ContainerTranslation id={"content." + ['formation'] + ".title"} tag="h2" />
						</div>

						{this.renderTraining(this.props.consultant.content.formation)}

					</div>

					{/*LANGUAGES*/}
					<div className="formulaire-section">

						<div className="formulaire-header">
							<ContainerTranslation id={"content." + ['language'] + ".title"} tag="h2" />
						</div>

						{this.renderLanguage(this.props.consultant.content.language)}

					</div>

					{/*CERTIFICATIONS*/}
					<div className="formulaire-section">

						<div className="formulaire-header">
							<ContainerTranslation id={"content." + ['certification'] + ".title"} tag="h2" />
						</div>

						{this.renderCertification(this.props.consultant.content.certification)}

					</div>


					{/*accreditation-body*/}
					{this.user.group !== "aegis" ? null :
						<div className="formulaire-section">

							<div className="formulaire-header" ref={"accreditation-body"}>
								<h2>Accreditation body</h2>
								<div style={{ width: 350 }}>
									{this.renderCreateAccreditationBodySkillsInput()}
								</div>
							</div>
							<AccreditationBodyFields
								values={this.props.consultant.content['accreditation-body']}
								translate={this.props.translate}
								list={this.props.list}
								handleBlurFactory={this.handleBlurFactory.bind(this)}
								handleRemoveFactory={this.handleRemoveFactory.bind(this)}
								handleInputChangeFactory={this.handleFieldsOnChangeFactory.bind(this)}
								updateFieldImageFactory={this.updateFieldImageFactory.bind(this)}
								downloadFieldImageFactory={this.downloadFieldImageFactory.bind(this)}
							/>

							<div key={'accreditation-body-duplicate'} className="duplicate" onClick={this.duplicate.bind(this, 'accreditation-body')}>
								<AddButton />
							</div>
						</div>
					}






					{/*ENVIRONNEMENT*/}

			<div className="formulaire-section" style={{ width: '80%' }}>
			  <div className="formulaire-header" ref={"environnement"}>
				<ContainerTranslation id={"content." + ['environnement'] + ".title"} tag="h2" />
				<div className={"formulaire-field tabs"}>
				  <div style={{backgroundColor: this.feedBackEnvironnement(valueExpEnergy) }} className={"formulaire-field tab" + classEnergy} >
					<i className="fas fa-plug" style={{ marginRight: "10px" }}></i><ContainerTranslation id={"secteur.Energy"} />
					<div className={"inline"} style={{ width: '90px', marginTop: '10px', display: 'block' }}>
					  <InputNumber
						onBlur={this.handleDomainExpChangeFactory("Energy")}
						value={valueExpEnergy}
						name={'environnement-experience'}
						isRequired={false}
						label={{title : this.props.translate("content.environnement.environnement-experience.title")}}
						suffix={this.props.translate('years')}
					  />
					</div>
				  </div>
				  <div style={{backgroundColor: this.feedBackEnvironnement(valueExpRailway)}} className={"formulaire-field tab" + classRailway} >
					<i className="fas fa-train" style={{ marginRight: "10px" }}></i><ContainerTranslation id={"secteur.Railway"} />
					<div className={"inline"} style={{ width: '90px', marginTop: '10px', display: 'block' }}>
					  <InputNumber
						onBlur={this.handleDomainExpChangeFactory("Railway")}
						value={valueExpRailway}
						name={'environnement-experience'}
						isRequired={false}
						label={{title : this.props.translate("content.environnement.environnement-experience.title")}}
						suffix={this.props.translate('years')}
					  />
					</div>
				  </div>
				</div>
			  </div>

						{this.props.consultant.content.environnement["environnement-domain"].Railway > 0 ?
							<>
								<div>
									{this.renderContexts("Railway")}
								</div>
							</> : null}

						{this.props.consultant.content.environnement["environnement-domain"].Energy > 0 ?
							<>
								<div>
									{this.renderContexts("Energy")}
								</div>
							</> : null}


					</div>


			{/*TECHNICAL SKILLS*/}
			<div className="formulaire-section">
			  <div className="formulaire-header" ref={"expertise"}>
				<ContainerTranslation id={"content." + ['expertise'] + ".title"} tag="h2" />
				<div style={{ width: 350 }}>
				  {this.renderCreateTechnicalSkillsInput()}
				</div>
			  </div>
			  <TechnicalFields
				values = {this.props.consultant.content['expertise']}
				translate={this.props.translate}
				list = {this.props.list}
				handleBlurFactory = {this.handleBlurFactory.bind(this)}
				handleRemoveFactory = {this.handleRemoveFactory.bind(this)}
							handleInputChangeFactory={this.handleFieldsOnChangeFactory.bind(this)}
							updateFieldImageFactory={this.updateFieldImageFactory.bind(this)}
							downloadFieldImageFactory={this.downloadFieldImageFactory.bind(this)}
			  />
			  <div key={'expertise-duplicate'} className="duplicate" onClick={this.duplicate.bind(this, 'expertise')}>
				<AddButton />
			  </div>
			</div>

					{/*OPERATIONAL SKILLS*/}
					<div className="formulaire-section">

						<div className="formulaire-header" ref={"intervention-level"}>
							<ContainerTranslation id={"content." + ['intervention-level'] + ".title"} tag="h2" />
							<div style={{ width: 350 }}>
								{this.renderCreateOperationalSkillsInput()}
							</div>
						</div>
						<OperationalFields
							values={this.props.consultant.content['intervention-level']}
							translate={this.props.translate}
							list={this.props.list}
							handleBlurFactory={this.handleBlurFactory.bind(this)}
							handleRemoveFactory={this.handleRemoveFactory.bind(this)}
							handleInputChangeFactory={this.handleFieldsOnChangeFactory.bind(this)}
							updateFieldImageFactory={this.updateFieldImageFactory.bind(this)}
							downloadFieldImageFactory={this.downloadFieldImageFactory.bind(this)}
						/>
						<div key={'intervention-level-duplicate'} className="duplicate" onClick={this.duplicate.bind(this, 'intervention-level')}>
							<AddButton />
						</div>
					</div>

					{/*INGENERING SKILLS*/}
					<div className="formulaire-section">
						<div className="formulaire-header" ref={"engineering"}>
							<ContainerTranslation id={"content." + ['engineering'] + ".title"} tag="h2" />
							<div style={{ width: 350 }}>
								{this.renderCreateEngineeringSkillsInput()}
							</div>
						</div>
						<EngineeringFields
							values={this.props.consultant.content['engineering']}
							translate={this.props.translate}
							list={this.props.list}
							handleBlurFactory={this.handleBlurFactory.bind(this)}
							handleRemoveFactory={this.handleRemoveFactory.bind(this)}
							handleInputChangeFactory={this.handleFieldsOnChangeFactory.bind(this)}
							updateFieldImageFactory={this.updateFieldImageFactory.bind(this)}
							downloadFieldImageFactory={this.downloadFieldImageFactory.bind(this)}
						/>
						<div key={'engineering-duplicate'} className="duplicate" onClick={this.duplicate.bind(this, 'engineering')}>
							<AddButton />
						</div>
					</div>

					{/*IMPLICATION*/}
					<div className="formulaire-section">
						<div className="formulaire-header">
							<ContainerTranslation id={"content." + ['implication'] + ".title"} tag="h2" />
						</div>
						{this.renderImplications()}
					</div>

			{/*TOOLS*/}
			<div className="formulaire-section">
			  <div className="formulaire-header" ref={"tools"}>
				<ContainerTranslation id={"content." + ['tools'] + ".title"} tag="h2" />
			  </div>
                        <ToolFields
                            values={this.props.consultant.content['tools']}
                            translate={this.props.translate}
                            list={this.props.list}
                            handleBlurFactory={this.handleBlurFactory.bind(this)}
                            handleRemoveFactory={this.handleRemoveFactory.bind(this)}
                            handleInputChangeFactory={this.handleFieldsOnChangeFactory.bind(this)}
                            updateFieldImageFactory={this.updateFieldImageFactory.bind(this)}
                            downloadFieldImageFactory={this.downloadFieldImageFactory.bind(this)}
                        />
			  <div key={'tool-duplicate'} className="duplicate" onClick={this.duplicate.bind(this, 'tools')}>
				<AddButton />
			  </div>
			</div>


					{/*HOBBIES*/}
					<div className="formulaire-section">
						<div className="formulaire-header">
							<ContainerTranslation id={"content." + ['hobbies'] + ".title"} tag="h2" />
						</div>
						<div className={"formulaire wide"}>
							<div className={"formulaire-field select"}>
								<CreatableSelectLabeled
									label={{ title: this.props.translate('content.hobbies.hobbie.title') }}
									onChange={this.handleInputChangeFactoryNew('hobbies')}
									value={this.props.consultant.content['hobbies'] ? this.props.consultant.content['hobbies'].map((h) => { return { value: h, label: h } }) : []}
									options={this.props.list.hobbies.map((ele) => { return { value: ele, label: ele } })}
									multi={true}
								/>
							</div>
						</div>
					</div>

					{/*END NEW FORM*/}
					<div className="form-centered y-spaced">
						<p>{this.props.consultant.progression.globalPercentage}<ContainerTranslation id={"nav." + ['completed']} /></p>
					</div>
					<div className="form-centered y-spaced">
						<Link to={route}><button className="view-btn"><ContainerTranslation id={"nav." + ['Back to the dashboard']} /></button></Link>
					</div>
					<div className="form-centered y-spaced" >

							{this.renderValidate(route)}

					</div>
					<div className="form-centered y-spaced" >

							{this.renderReject(route)}

					</div>
					<div className="form-centered y-spaced" >

							{this.renderExpire(route)}

					</div>
					<div className="form-centered y-spaced" style={{ paddingBottom:"20px" }}>

							{this.renderSubmit(route)}

					</div>
					<div className="scrollTop" onClick={this.scrollTop.bind(this)}>
						<i className="fas fa-arrow-up" style={{ color: "#E30119" }}></i>
					</div>
				</div>
			</div>
		)
	}
}

const mapStateToProps = state => ({
	list: state.consultant.list,
	message: state.consultant.message,
	user: state.consultant.consultant.user,
	consultant: state.consultant.consultant,
	error: state.consultant.error
})

const mapDispatchToProps = dispatch => bindActionCreators({
	fetchConsultant,
	updateFieldConsultant,
	addFieldConsultant,
	removeFieldConsultant,
	getAutocompleteList,
	validate,
	updateFieldImageConsultant,
	downloadFieldImageConsultant,
	submit,
	draft,
	reject,
	expire,
	resetError
}, dispatch);






class AccreditationBodyFields extends React.Component {



	render() {
		
		return (
			<div className={"formulaire wide"}>
				<div className={"formulaire-field text"}>
					{this.props.values.map((content, i) => {
						return (
							<AccreditationBodyField
								key={`accreditation-body-field-${i}`}
								index={i}
								value={content}
								options={this.props.list}
								removeHandler={this.props.handleRemoveFactory('accreditation-body', i)}
								handleFieldOnChangeFactory={this.props.handleInputChangeFactory('accreditation-body', i)}
								blurHandler={this.props.handleBlurFactory('accreditation-body', i)}
								translate={this.props.translate}
								updateFieldImage={this.props.updateFieldImageFactory("accreditation-document", 'accreditation-body', i)}
								downloadFieldImage={this.props.downloadFieldImageFactory("accreditation-document", 'accreditation-body', i) }
							/>
						)
					})}
				</div>
			</div>
		)
	}

}



class AccreditationBodyField extends React.Component {

	

	shouldComponentUpdate(nextProps, nextState) {

		

		if (this.props.value['level-1'] !== nextProps.value['level-1']) {
			return true;
		}
		if (this.props.value['level-2'] !== nextProps.value['level-2']) {
			return true;
		}
		if (this.props.value['level-3'] !== nextProps.value['level-3']) {
			return true;
		}
		if (this.props.value['level-4'] !== nextProps.value['level-4']) {
			return true;
		}
		if (this.props.value['expertise'] !== nextProps.value['expertise']) {
			return true;
		}
		if (this.props.value['experience'] !== nextProps.value['experience']) {
			return true;
		}
		if (this.props.value['justification'] !== nextProps.value['justification']) {
			return true;
		}
		if (this.props.value['accreditation-document'] !== nextProps.value['accreditation-document']) {
			return true;
		}

		return false;
	}




	render() {

		

		let level2 = { value: "", label: "" };
		let level2Options = [];
		let level3 = { value: "", label: "" };
		let level3Options = [];
		let expertise = { value: "", label: "" };
		let expertiseOptions = [];

		let level1 = {
			value: this.props.value['level-1'],
			label: this.props.translate(`level-1.${this.props.value['level-1']}`)
		};
		let level1Options = this.props.options["accreditation-body"]['level-1'].map(
			(x) => { return { value: x, label: this.props.translate(`level-1.${x}`) } }
		);


		if (this.props.options["accreditation-body"]['level-2'][this.props.value['level-1']]) {
			level2 = {
				value: this.props.value['level-2'],
				label: this.props.translate(`level-2.${this.props.value['level-1']}.${this.props.value['level-2']}`)
			};
			level2Options = this.props.options["accreditation-body"]['level-2'][this.props.value['level-1']].map(
				(x) => { return { value: x, label: this.props.translate(`level-2.${this.props.value['level-1']}.${x}`) }}
			);
		}

		if (this.props.options["accreditation-body"]['level-3'][this.props.value['level-2']]) {
			level3 = {
				value: this.props.value['level-3'],
				label: this.props.translate(`level-3.${this.props.value['level-2']}.${this.props.value['level-3']}`)
			};
			level3Options = this.props.options["accreditation-body"]['level-3'][this.props.value['level-2']].map(
				(x) => { return { value: x, label: this.props.translate(`level-3.${this.props.value['level-2']}.${x}`) } }
			);
		}


		if (this.props.options['accreditation-body-expertise'][this.props.value['level-1']]) {
			expertise = { value: this.props.value['expertise'], label: this.props.translate(`aegis-expertise.${this.props.value['level-1']}.${this.props.value['expertise']}`) };
			expertiseOptions = this.props.options['accreditation-body-expertise'][this.props.value['level-1']].map(
				(x) => { return { value: x, label: this.props.translate(`aegis-expertise.${this.props.value['level-1']}.${x}`) } }
			);
		}


		return (
			<div key={`accreditation-body-field-2-${this.props.index}`} id={this.props.index}>
				<div className="separator">
					<div key={'accreditation-' + this.props.index} style={{ float: "right" }}>
						{this.props.value['accreditation-document'] !== "" && this.props.value['accreditation-document'] !== undefined ? <>
							<span className="delete-part"
								style={{ float: "none", marginLeft: "5px" }}
								onClick={(e) => this.props.downloadFieldImage()}
								key={'accreditationdownload-' + this.props.index}
								id={'accreditationdownload-' + this.props.index}>
								<i className="fas fa-file-download"
									title={this.props.translate('content.school.diploma.download')}
									style={{ color: '#ffffff' }}>
								</i>
							</span>
							<span className="delete-part"
								style={{ float: "none", marginLeft: "5px" }}
								onClick={(e) => this.props.updateFieldImage("")}
								key={'accreditationdelete-' + this.props.index}
								id={'accreditationdelete-' + this.props.index}>
								<i className="fas fa-window-close"
									title={this.props.translate('content.certification.certification-document.remove')}
									style={{ color: '#ffffff' }}>
								</i>
							</span>
						</> : null
						}
						<span className="delete-part" style={{ float: "none", marginLeft: "5px" }} key={'accreditationadd-' + this.props.index} id={'accreditationadd-' + this.props.index}>
							<label htmlFor={'accreditation-document' + this.props.index} style={{marginRight: "0px", marginBottom: "0px" }} >
								<i className="fas fa-file-upload"
								title={this.props.translate('content.school.diploma.upload')}
								style={{ color: '#ffffff'}} />
							</label>
							<input type="file"
								style={{ display: "none" }}
								onChange={(e) => this.props.updateFieldImage(e.target.files)}
								id={'accreditation-document' + this.props.index} />
						</span>
						<span style={{ width: "20px", display: "inline-block" }} />
						<div className="delete-part"
							onClick={this.props.removeHandler}
						>
						<i className="fas fa-trash" style={{ color: '#ffffff' }}></i>

						</div>
					</div>
				</div>

				<div className="competency-field-row flex">
					<div className="inline competency-widget-size-3">
					<SelectLabeled
						label={{ title: "group" }}
						value={level1}
						onChange={this.props.handleFieldOnChangeFactory('level-1')}
						options={level1Options}
					/>
					</div>
					<div className="fill-remaining-space" />
				{
						level2Options && level2Options.length > 0 ?
							<div className="inline competency-widget-size-3">
							<SelectLabeled
								label={{ title: "subject" }}
								value={level2}
								onChange={this.props.handleFieldOnChangeFactory('level-2')}
								options={level2Options}
							/>
							</div> : <div className="inline competency-widget-size-3" />
					}
					<div className="fill-remaining-space" />
				{
						level3Options && level3Options.length > 0 ?
							<div className="inline competency-widget-size-3">
							<SelectLabeled
								label={{ title: "skill" }}
								value={level3}
								onChange={this.props.handleFieldOnChangeFactory('level-3')}
								options={level3Options}
							/>
							</div> : <div className="inline competency-widget-size-3"/>
					}
				</div>
				<div className="competency-field-row flex">
					<div className="inline expertise-widget-size">
						<SelectLabeled
							label={{ title: this.props.translate("content.tools.tool-expertise.title") }}
							value={expertise}
							onChange={this.props.handleFieldOnChangeFactory('expertise')}
							options={expertiseOptions}
						/>
					</div>
					<div className="fill-remaining-space" />
					<div className="inline number-widget-size">
						<InputNumber
							onBlur={this.props.blurHandler}
							value={this.props.value["experience"]}
							name={"experience"}
							isRequired={true}
							label={{ title: this.props.translate("content.intervention-level.intervention-experience.title") }}
							suffix={this.props.translate('years')}
						/>
					</div>
				</div>
				<div className="competency-field-row">
					<TextAreaLabeled
						onBlur={this.props.blurHandler}
						name={'justification'}
						value={this.props.value['justification']}
						isRequired={true}
						label={{ title: 'justification' }}
						placeholder={this.props.translate(`content.tools.placeholder.${this.props.value['expertise']}`)}
						maxLength={1000}
						height={'100px'}
					/>
				</div>
			</div>
		)
	}

}








class OperationalFields extends React.Component {



  render(){
	return (
	  <div className={"formulaire wide"}>
		<div className={"formulaire-field text"}>
			{this.props.values.map((content,i)=>{
			  return(
				<OperationalField
				  key={`Operational-field-${i}`}
				  index={i}
				  value={content}
				  options={this.props.list}
				  removeHandler={this.props.handleRemoveFactory('intervention-level',i)}
				  handleFieldOnChangeFactory={this.props.handleInputChangeFactory('intervention-level', i)}
				  blurHandler={this.props.handleBlurFactory('intervention-level',i)}
					  translate={this.props.translate} 
					  updateFieldImage={this.props.updateFieldImageFactory("intervention-document", 'intervention-level', i)}
					  downloadFieldImage={this.props.downloadFieldImageFactory("intervention-document", 'intervention-level', i)}
				/>
			  )
			})}
		</div>
	  </div>
	)
  }

}




class OperationalField extends React.Component {



	shouldComponentUpdate(nextProps, nextState) {


		if (this.props.value['intervention-type'] !== nextProps.value['intervention-type']) {
			return true;
		}
		if (this.props.value['intervention-mission'] !== nextProps.value['intervention-mission']) {
			return true;
		}
		if (this.props.value['intervention-application'] !== nextProps.value['intervention-application']) {
			return true;
		}
		if (this.props.value['level-4'] !== nextProps.value['level-4']) {
			return true;
		}
		if (this.props.value['expertise'] !== nextProps.value['expertise']) {
			return true;
		}
		if (this.props.value['intervention-experience'] !== nextProps.value['intervention-experience']) {
			return true;
		}
		if (this.props.value['justification'] !== nextProps.value['justification']) {
			return true;
		}
		if (this.props.value['intervention-document'] !== nextProps.value['intervention-document']) {
			return true;
		}

		return false;
	}


	render() {


	  let interventionType = {
		  value: this.props.value['intervention-type'],
		  label: this.props.translate(`intervention-type.${this.props.value['intervention-type']}`)
	  };
	  let interventionTypeOptions = this.props.options.operational['intervention-type'].map(
		  (x) => { return { value: x, label: this.props.translate(`intervention-type.${x}`) } }
	  );

	  let interventionMission = { value: "", label: "" };
	  let interventionMissionOptions = [];
	  let interventionApplication = { value: "", label: "" };
	  let interventionApplicationOptions = [];
	  let level4 = { value: "", label: "" };
	  let level4Options = [];

	  if (this.props.options.operational['intervention-mission'][this.props.value['intervention-type']]) {
		  interventionMission = {
			  value: this.props.value['intervention-mission'],
			  label: this.props.translate(`intervention-mission.${this.props.value['intervention-type']}.${this.props.value['intervention-mission']}`)
		  };
		  interventionMissionOptions = this.props.options.operational['intervention-mission'][this.props.value['intervention-type']].map(
			  (x) => { return { value: x, label: this.props.translate(`intervention-mission.${this.props.value['intervention-type']}.${x}`) } }
		  );
	  }

	  if (this.props.options.operational['intervention-application'][this.props.value['intervention-mission']]) {
		  interventionApplication = {
			  value: this.props.value['intervention-application'],
			  label: this.props.translate(`intervention-application.${this.props.value['intervention-mission']}.${this.props.value['intervention-application']}`)
		  };
		  interventionApplicationOptions = this.props.options.operational['intervention-application'][this.props.value['intervention-mission']].map(
			  (x) => { return { value: x, label: this.props.translate(`intervention-application.${this.props.value['intervention-mission']}.${x}`) } }
		  );
	  }


	  if (this.props.options.operational['intervention-level-4'][this.props.value['intervention-application']]) {
		  level4 = {
			  value: this.props.value['level-4'],
			  label: this.props.value['level-4']
		  };
		  level4Options = this.props.options.operational['intervention-level-4'][this.props.value['intervention-application']].map(
			  (x) => { return { value: x, label: x } }
		  );
	  }
	  
	  const expertise = { value: this.props.value['expertise'], label: this.props.translate(`content.tools.tool-level.${this.props.value['expertise']}`) };
	  const expertiseOptions = this.props.options['tool-expertise'].map((x) => { return { value: x, label: this.props.translate(`content.tools.tool-level.${x}`) } });

	  return (
		  <div key={`operational-field-2-${this.props.index}`} id={this.props.index}>
			  <div className="separator">
				  <div key={'operational-' + this.props.index} style={{ float: "right" }}>
					  {this.props.value['intervention-document'] !== "" && this.props.value['intervention-document'] !== undefined ? <>
						  <span className="delete-part"
							  style={{ float: "none", marginLeft: "5px" }}
							  onClick={(e) => this.props.downloadFieldImage()}
							  key={'operationaldownload-' + this.props.index}
							  id={'operationaldownload-' + this.props.index}>
							  <i className="fas fa-file-download"
								  title={this.props.translate('content.school.diploma.download')}
								  style={{ color: '#ffffff' }}>
							  </i>
						  </span>
						  <span className="delete-part"
							  style={{ float: "none", marginLeft: "5px" }}
							  onClick={(e) => this.props.updateFieldImage("")}
							  key={'operationaldelete-' + this.props.index}
							  id={'operationaldelete-' + this.props.index}>
							  <i className="fas fa-window-close"
								  title={this.props.translate('content.certification.certification-document.remove')}
								  style={{ color: '#ffffff' }}>
							  </i>
						  </span>
					  </> : null
					  }
					  <span className="delete-part" style={{ float: "none", marginLeft: "5px" }} key={'operationaladd-' + this.props.index} id={'operationaladd-' + this.props.index}>
						  <label htmlFor={'intervention-document' + this.props.index} style={{ marginRight: "0px", marginBottom: "0px" }} >
							  <i className="fas fa-file-upload"
								  title={this.props.translate('content.school.diploma.upload')}
								  style={{ color: '#ffffff' }} />
						  </label>
						  <input type="file"
							  style={{ display: "none" }}
							  onChange={(e) => this.props.updateFieldImage(e.target.files)}
							  id={'intervention-document' + this.props.index} />
					  </span>
					  <span style={{ width: "20px", display: "inline-block" }} />
					  <div className="delete-part" onClick={this.props.removeHandler}>
						<i className="fas fa-trash" style={{ color: '#ffffff' }}></i>

					  </div>
					</div>
			  </div>

			  <div className="competency-field-row flex">
				  <div className="inline competency-widget-size-4">
				  <SelectLabeled
						  label={{ title: this.props.translate("content.intervention-level.intervention-type.title") }}
					  value={interventionType}
					  onChange={this.props.handleFieldOnChangeFactory('intervention-type')}
					  options={interventionTypeOptions}
				  />
				  </div>
				  <div className="fill-remaining-space" />
			  {
					  interventionMissionOptions && interventionMissionOptions.length > 0 ? 
						  <div className="inline competency-widget-size-4">
						  <SelectLabeled
								  label={{ title: this.props.translate("content.intervention-level.intervention-mission.title") }}
							  value={interventionMission}
							  onChange={this.props.handleFieldOnChangeFactory('intervention-mission')}
							  options={interventionMissionOptions}
						  />
						  </div> : <div className="inline competency-widget-size-4"/>
				  }
				  <div className="fill-remaining-space" />
			  {
					  interventionApplicationOptions && interventionApplicationOptions.length > 0 ?
						  <div className="inline competency-widget-size-4">
						  <SelectLabeled
								  label={{ title: this.props.translate("content.intervention-level.intervention-application.title") }}
							  value={interventionApplication}
							  onChange={this.props.handleFieldOnChangeFactory('intervention-application')}
							  options={interventionApplicationOptions}
						  />
						  </div> : <div className="inline competency-widget-size-4" />
				  }
				  <div className="fill-remaining-space" />
			  {
					  level4Options && level4Options.length > 0 ?
						  <div className="inline competency-widget-size-4">
						  <SelectLabeled
								  label={{ title: this.props.translate("content.intervention-level.intervention-other.title") }}
							  value={level4}
							  onChange={this.props.handleFieldOnChangeFactory('level-4')}
							  options={level4Options}
						  />
						  </div> : <div className="inline competency-widget-size-4" />
				  }
			  </div>
			  <div className="competency-field-row flex">
				  <div className="inline expertise-widget-size">
					  <SelectLabeled
						  label={{ title: this.props.translate("content.tools.tool-expertise.title") } }
						  value={expertise}
						  onChange={this.props.handleFieldOnChangeFactory('expertise')}
						  options={expertiseOptions}
					  />
				  </div>
				  <div className="fill-remaining-space" />
				  <div className="inline number-widget-size">
					  <InputNumber
						  onBlur={this.props.blurHandler}
						  value={this.props.value["intervention-experience"]}
						  name={"intervention-experience"}
						  isRequired={true}
						  label={{title : this.props.translate("content.intervention-level.intervention-experience.title")}}
						  suffix={this.props.translate('years')}
					  />
				  </div>
			  </div>
			  <div className="competency-field-row">
				  <TextAreaLabeled
					  onBlur={this.props.blurHandler}
					  name={'justification'}
					  value={this.props.value['justification']}
					  isRequired={true}
					  label={{title :'justification'}}
					  placeholder={this.props.translate(`content.tools.placeholder.${this.props.value['expertise']}`)}
					  maxLength={1000}
					  height={'100px'}
				  />
			</div>
		</div>
	  )
  }

}


class EngineeringFields extends React.Component {



  render(){
	return (
	  <div className={"formulaire wide"}>
		<div className={"formulaire-field text"}>
			{this.props.values.map((content,i)=>{
			  return(
				<EngineeringField
				  key={`Engineering-field-${i}`}
				  index={i}
				  value={content}
				  options={this.props.list}
					  removeHandler={this.props.handleRemoveFactory('engineering', i)}
					  handleFieldOnChangeFactory={this.props.handleInputChangeFactory('engineering', i)}
				  blurHandler={this.props.handleBlurFactory('engineering',i)}
					  translate={this.props.translate}
					  updateFieldImage={this.props.updateFieldImageFactory("engineering-document", 'engineering', i)}
					  downloadFieldImage={this.props.downloadFieldImageFactory("engineering-document", 'engineering', i)}
				/>
			  )
			})}
		</div>
	  </div>
	)
  }

}


class EngineeringField extends React.Component {




	shouldComponentUpdate(nextProps, nextState) {


		if (this.props.value['engineering-skill'] !== nextProps.value['engineering-skill']) {
			return true;
		}
		if (this.props.value['engineering-specialization'] !== nextProps.value['engineering-specialization']) {
			return true;
		}
		if (this.props.value['expertise'] !== nextProps.value['expertise']) {
			return true;
		}
		if (this.props.value['intervention-experience'] !== nextProps.value['intervention-experience']) {
			return true;
		}
		if (this.props.value['justification'] !== nextProps.value['justification']) {
			return true;
		}
		if (this.props.value['engineering-document'] !== nextProps.value['engineering-document']) {
			return true;
		}

		return false;
	}

	render() {

	  let engineeringSkill = {
		  value: this.props.value['engineering-skill'],
		  label: this.props.translate(`engineering-skill.${this.props.value['engineering-skill']}`)
	  };
	  let engineeringSkillOptions = this.props.options.engineering['engineering-skill'].map(
		  (x) => { return { value: x, label: this.props.translate(`engineering-skill.${x}`) } }
	  );

	  let engineeringSpecialization = { value: "", label: "" };
	  let engineeringSpecializationOptions = [];

	  if (this.props.options.engineering['engineering-specialization'][this.props.value['engineering-skill']]) {
		  engineeringSpecialization = {
			  value: this.props.value['engineering-specialization'],
			  label: this.props.translate(`engineering-specialization.${this.props.value['engineering-skill']}.${this.props.value['engineering-specialization']}`)
		  };
		  engineeringSpecializationOptions = this.props.options.engineering['engineering-specialization'][this.props.value['engineering-skill']].map(
			  (x) => { return { value: x, label: this.props.translate(`engineering-specialization.${this.props.value['engineering-skill']}.${x}`) } }
		  );
	  }

	  const expertise = { value: this.props.value['expertise'], label: this.props.translate(`content.tools.tool-level.${this.props.value['expertise']}`) };
	  const expertiseOptions = this.props.options['tool-expertise'].map((x) => { return { value: x, label: this.props.translate(`content.tools.tool-level.${x}`) } });

	  return (
		  <div key={`engineering-field-2-${this.props.index}`} id={this.props.index}>
			  <div className="separator">
				  <div key={'engineering-' + this.props.index} style={{ float: "right" }}>
					  {this.props.value['engineering-document'] !== "" && this.props.value['engineering-document'] !== undefined ? <>
						  <span className="delete-part"
							  style={{ float: "none", marginLeft: "5px" }}
							  onClick={(e) => this.props.downloadFieldImage()}
							  key={'engineeringdownload-' + this.props.index}
							  id={'engineeringdownload-' + this.props.index}>
							  <i className="fas fa-file-download"
								  title={this.props.translate('content.school.diploma.download')}
								  style={{ color: '#ffffff' }}>
							  </i>
						  </span>
						  <span className="delete-part"
							  style={{ float: "none", marginLeft: "5px" }}
							  onClick={(e) => this.props.updateFieldImage("")}
							  key={'engineeringdelete-' + this.props.index}
							  id={'engineeringdelete-' + this.props.index}>
							  <i className="fas fa-window-close"
								  title={this.props.translate('content.certification.certification-document.remove')}
								  style={{ color: '#ffffff' }}>
							  </i>
						  </span>
					  </> : null
					  }
					  <span className="delete-part" style={{ float: "none", marginLeft: "5px" }} key={'engineeringadd-' + this.props.index} id={'engineeringadd-' + this.props.index}>
						  <label htmlFor={'engineering-document' + this.props.index} style={{ marginRight: "0px", marginBottom: "0px" }} >
							  <i className="fas fa-file-upload"
								  title={this.props.translate('content.school.diploma.upload')}
								  style={{ color: '#ffffff' }} />
						  </label>
						  <input type="file"
							  style={{ display: "none" }}
							  onChange={(e) => this.props.updateFieldImage(e.target.files)}
							  id={'engineering-document' + this.props.index} />
					  </span>
					  <span style={{ width: "20px", display: "inline-block" }} />
					  <div className="delete-part"
						  onClick={this.props.removeHandler}
					  >
						  <i className="fas fa-trash" style={{ color: '#ffffff' }}></i>

					  </div>
				  </div>

			  </div>

			  <div className="competency-field-row flex">
				  <div className="inline competency-widget-size-2">
					  <SelectLabeled
						  label={{ title: this.props.translate("content.engineering.engineering-skill.title") }}
						  value={engineeringSkill}
						  onChange={this.props.handleFieldOnChangeFactory('engineering-skill')}
						  options={engineeringSkillOptions}
					  />
				  </div>
				  <div className="fill-remaining-space" />
				  {
					  engineeringSpecializationOptions && engineeringSpecializationOptions.length > 0 ? 
						  <div className="inline competency-widget-size-2">
							  <SelectLabeled
								  label={{ title: this.props.translate("content.engineering.engineering-specialization.title") }}
								  value={engineeringSpecialization}
								  onChange={this.props.handleFieldOnChangeFactory('engineering-specialization')}
								  options={engineeringSpecializationOptions}
							  />
						  </div> : null
					  }
			  </div>
			  <div className="competency-field-row flex">
				  <div className="inline expertise-widget-size">
					  <SelectLabeled
						  label={{ title: this.props.translate("content.tools.tool-expertise.title") }}
						  value={expertise}
						  onChange={this.props.handleFieldOnChangeFactory('expertise')}
						  options={expertiseOptions}
					  />
				  </div>
				  <div className="fill-remaining-space" />
				  <div className="inline number-widget-size">
					  <InputNumber
						  onBlur={this.props.blurHandler}
						  value={this.props.value["engineering-experience"]}
						  name={"engineering-experience"}
						  isRequired={true}
						  label={{title : this.props.translate("content.intervention-level.intervention-experience.title")}}
						  suffix={this.props.translate('years')}
					  />
				  </div>
			  </div>
			  <div className="competency-field-row">
				  <TextAreaLabeled
					  onBlur={this.props.blurHandler}
					  name={'justification'}
					  value={this.props.value['justification']}
					  isRequired={true}
					  label={{title :'justification'}}
					  placeholder={this.props.translate(`content.tools.placeholder.${this.props.value['expertise']}`)}
					  maxLength={1000}
					  height={'100px'}
				  />
			</div>
		</div>
	  )
  }

}



class TechnicalFields extends React.Component {

	
	render() {
		
	return (
	  <div className={"formulaire wide"}>
		<div className={"formulaire-field text"}>
			{this.props.values.map((content,i)=>{
			  return(
				<TechnicalField
				  key={`Technical-field-${i}`}
				  index={i}
				  value={content}
				  options={this.props.list}
					  removeHandler={this.props.handleRemoveFactory('expertise', i)}
					  handleFieldOnChangeFactory={this.props.handleInputChangeFactory('expertise', i)}
				  blurHandler={this.props.handleBlurFactory('expertise',i)}
					  translate={this.props.translate}
					  updateFieldImage={this.props.updateFieldImageFactory("domain-document", 'expertise', i)}
					  downloadFieldImage={this.props.downloadFieldImageFactory("domain-document", 'expertise', i)}
				/>
			  )
			})}
		</div>
	  </div>
	)
  }

}

class TechnicalField extends React.Component {


	shouldComponentUpdate(nextProps, nextState) {


		if (this.props.value['domain-competence'] !== nextProps.value['domain-competence']) {
			return true;
		}
		if (this.props.value['domain-speciality'] !== nextProps.value['domain-speciality']) {
			return true;
		}
		if (this.props.value['domain-specificity'] !== nextProps.value['domain-specificity']) {
			return true;
		}
		if (this.props.value['expertise'] !== nextProps.value['expertise']) {
			return true;
		}
		if (this.props.value['intervention-experience'] !== nextProps.value['intervention-experience']) {
			return true;
		}
		if (this.props.value['justification'] !== nextProps.value['justification']) {
			return true;
		}
		if (this.props.value['domain-document'] !== nextProps.value['domain-document']) {
			return true;
		}

		return false;
	}


	render() {

	  let domainCompetence = {
		  value: this.props.value['domain-competence'],
		  label: this.props.translate(`domain-competence.${this.props.value['domain-competence']}`)
	  };
	  let domainCompetenceOptions = this.props.options.technical['domain-competence']['Energy'].concat(this.props.options.technical['domain-competence']['Railway']).map(
		  (x) => { return { value: x, label: this.props.translate(`domain-competence.${x}`) } }
	  );


	  let domainSpeciality = { value: "", label: "" };
	  let domainSpecialityOptions = [];

	  let domainSpecificity = { value: "", label: "" };
	  let domainSpecificityOptions = [];

	  if (this.props.options.technical['domain-speciality'][this.props.value['domain-competence']]) {
		  domainSpeciality = {
			  value: this.props.value['domain-speciality'],
			  label: this.props.translate(`domain-speciality.${this.props.value['domain-competence']}.${this.props.value['domain-speciality']}`)
		  };
		  domainSpecialityOptions = this.props.options.technical['domain-speciality'][this.props.value['domain-competence']].map(
			  (x) => { return { value: x, label: this.props.translate(`domain-speciality.${this.props.value['domain-competence']}.${x}`) } }
		  );
	  }

	  if (this.props.options.technical['domain-specificity'][this.props.value['domain-speciality']]) {
		  domainSpecificity = {
			  value: this.props.value['domain-specificity'],
			  label: this.props.translate(`domain-specificity.${this.props.value['domain-speciality']}.${this.props.value['domain-specificity']}`)
		  };
		  domainSpecificityOptions = this.props.options.technical['domain-specificity'][this.props.value['domain-speciality']].map(
			  (x) => { return { value: x, label: this.props.translate(`domain-specificity.${this.props.value['domain-speciality']}.${x}`) } }
		  );
	  }



	  const expertise = { value: this.props.value['expertise'], label: this.props.translate(`content.tools.tool-level.${this.props.value['expertise']}`) };
	  const expertiseOptions = this.props.options['tool-expertise'].map((x) => { return { value: x, label: this.props.translate(`content.tools.tool-level.${x}`) } });

	  return (
		  <div>
			  <div className="separator">
				  <div key={'expertise-' + this.props.index} style={{ float: "right" }}>
					  {this.props.value['domain-document'] !== "" && this.props.value['domain-document'] !== undefined ? <>
						  <span className="delete-part"
							  style={{ float: "none", marginLeft: "5px" }}
							  onClick={(e) => this.props.downloadFieldImage()}
							  key={'expertisedownload-' + this.props.index}
							  id={'expertisedownload-' + this.props.index}>
							  <i className="fas fa-file-download"
								  title={this.props.translate('content.school.diploma.download')}
								  style={{ color: '#ffffff' }}>
							  </i>
						  </span>
						  <span className="delete-part"
							  style={{ float: "none", marginLeft: "5px" }}
							  onClick={(e) => this.props.updateFieldImage("")}
							  key={'expertisedelete-' + this.props.index}
							  id={'expertisedelete-' + this.props.index}>
							  <i className="fas fa-window-close"
								  title={this.props.translate('content.certification.certification-document.remove')}
								  style={{ color: '#ffffff' }}>
							  </i>
						  </span>
					  </> : null
					  }
					  <span className="delete-part" style={{ float: "none", marginLeft: "5px" }} key={'expertiseadd-' + this.props.index} id={'expertiseadd-' + this.props.index}>
						  <label htmlFor={'domain-document' + this.props.index} style={{ marginRight: "0px", marginBottom: "0px" }} >
							  <i className="fas fa-file-upload"
								  title={this.props.translate('content.school.diploma.upload')}
								  style={{ color: '#ffffff' }} />
						  </label>
						  <input type="file"
							  style={{ display: "none" }}
							  onChange={(e) => this.props.updateFieldImage(e.target.files)}
							  id={'domain-document' + this.props.index} />
					  </span>
					  <span style={{ width: "20px", display: "inline-block" }} />
					  <div className="delete-part"
						  onClick={this.props.removeHandler}
					  >
						  <i className="fas fa-trash" style={{ color: '#ffffff' }}></i>

					  </div>
				  </div>

			  </div>

			  <div className="competency-field-row flex">
				  <div className="inline competency-widget-size-3">
					  <SelectLabeled
						  label={{ title: this.props.translate("content.expertise.domain-competence.title") }}
						  value={domainCompetence}
						  onChange={this.props.handleFieldOnChangeFactory('domain-competence')}
						  options={domainCompetenceOptions}
					  />
				  </div>
				  <div className="fill-remaining-space" />
				  {
					  domainSpecialityOptions && domainSpecialityOptions.length > 0 ? 
						  <div className="inline competency-widget-size-3">
							  <SelectLabeled
								  label={{ title: this.props.translate("content.expertise.domain-speciality.title") }}
								  value={domainSpeciality}
								  onChange={this.props.handleFieldOnChangeFactory('domain-speciality')}
								  options={domainSpecialityOptions}
							  />
						  </div> : <div className="inline competency-widget-size-3"/>
				  }
				  <div className="fill-remaining-space" />
				  {
					  domainSpecificityOptions && domainSpecificityOptions.length > 0 ?
						  <div className="inline competency-widget-size-3">
							  <SelectLabeled
								  label={{ title: this.props.translate("content.expertise.domain-specificity.title") }}
								  value={domainSpecificity}
								  onChange={this.props.handleFieldOnChangeFactory('domain-specificity')}
								  options={domainSpecificityOptions}
							  />
						  </div> : <div className="inline competency-widget-size-3" />
					  }
			  </div>
			  <div className="competency-field-row flex">
				  <div className="inline expertise-widget-size">
					  <SelectLabeled
						  label={{ title: this.props.translate("content.tools.tool-expertise.title") }}
						  value={expertise}
						  onChange={this.props.handleFieldOnChangeFactory('expertise')}
						  options={expertiseOptions}
					  />
				  </div>
				  <div className="fill-remaining-space" />
				  <div className="inline number-widget-size">
					  <InputNumber
						  onBlur={this.props.blurHandler}
						  value={this.props.value["domain-experience"]}
						  name={"domain-experience"}
						  isRequired={true}
						  label={{title : this.props.translate("content.intervention-level.intervention-experience.title")}}
						  suffix={this.props.translate('years')}
					  />
				  </div>
			  </div>
			  <div className="competency-field-row">
				  <TextAreaLabeled
					  onBlur={this.props.blurHandler}
					  name={'justification'}
					  value={this.props.value['justification']}
					  isRequired={true}
					  label={{title :'justification'}}
					  placeholder={this.props.translate(`content.tools.placeholder.${this.props.value['expertise']}`)}
					  maxLength={1000}
					  height={'100px'}
				  />
			</div>
		</div>
	  )
  }

}


class ToolFields extends React.Component {


  render(){
	return (
	  <div className={"formulaire wide"}>
		<div className={"formulaire-field text"}>
			{this.props.values.map((content,i)=>{
			  return(
				<ToolField
				  key={`Tool-field-${i}`}
				  index={i}
				  value={content}
				  options={this.props.list}
				  removeHandler={this.props.handleRemoveFactory('tools',i)}
				  handleFieldOnChangeFactory={this.props.handleInputChangeFactory('tools',i)}
				  blurHandler={this.props.handleBlurFactory('tools',i)}
					  translate={this.props.translate}
					  updateFieldImage={this.props.updateFieldImageFactory("document", 'tools', i)}
					  downloadFieldImage={this.props.downloadFieldImageFactory("document", 'tools', i)}
				/>
			  )
			})}
		</div>
	  </div>
	)
  }

}


class ToolField extends React.Component {


	shouldComponentUpdate(nextProps, nextState) {


		if (this.props.translate('content.tools.tool.title') !== nextProps.translate('content.tools.tool.title')) {
			return true;
		}

		if (this.props.value['name'] !== nextProps.value['name']) {
			return true;
		}
		if (this.props.value['expertise'] !== nextProps.value['expertise']) {
			return true;
		}
		if (this.props.value['intervention-experience'] !== nextProps.value['intervention-experience']) {
			return true;
		}
		if (this.props.value['justification'] !== nextProps.value['justification']) {
			return true;
		}
		if (this.props.value['document'] !== nextProps.value['document']) {
			return true;
		}


		return false;
	}


	render() {

	  const value = {value : this.props.value['expertise'], label: this.props.translate(`content.tools.tool-level.${this.props.value['expertise']}`) };
	  const options = this.props.options['tool-expertise'].map((x)=>{return{value : x, label : this.props.translate(`content.tools.tool-level.${x}`)}})

	  return (
			  <div >
			  <div className="separator">
				  <div key={'tool-' + this.props.index} style={{ float: "right" }}>
					  {this.props.value['document'] !== "" && this.props.value['document'] !== undefined ? <>
						  <span className="delete-part"
							  style={{ float: "none", marginLeft: "5px" }}
							  onClick={(e) => this.props.downloadFieldImage()}
							  key={'tooldownload-' + this.props.index}
							  id={'tooldownload-' + this.props.index}>
							  <i className="fas fa-file-download"
								  title={this.props.translate('content.school.diploma.download')}
								  style={{ color: '#ffffff' }}>
							  </i>
						  </span>
						  <span className="delete-part"
							  style={{ float: "none", marginLeft: "5px" }}
							  onClick={(e) => this.props.updateFieldImage("")}
							  key={'tooldelete-' + this.props.index}
							  id={'tooldelete-' + this.props.index}>
							  <i className="fas fa-window-close"
								  title={this.props.translate('content.certification.certification-document.remove')}
								  style={{ color: '#ffffff' }}>
							  </i>
						  </span>
					  </> : null
					  }
					  <span className="delete-part" style={{ float: "none", marginLeft: "5px" }} key={'tooladd-' + this.props.index} id={'tooladd-' + this.props.index}>
						  <label htmlFor={'tool-document' + this.props.index} style={{ marginRight: "0px", marginBottom: "0px" }} >
							  <i className="fas fa-file-upload"
								  title={this.props.translate('content.school.diploma.upload')}
								  style={{ color: '#ffffff' }} />
						  </label>
						  <input type="file"
							  style={{ display: "none" }}
							  onChange={(e) => this.props.updateFieldImage(e.target.files)}
							  id={'tool-document' + this.props.index} />
					  </span>
					  <span style={{ width: "20px", display: "inline-block" }} />
					  <div className="delete-part"
						  onClick={this.props.removeHandler}
					  >
						  <i className="fas fa-trash" style={{ color: '#ffffff' }}></i>

					  </div>
				  </div>

			  </div>
			  <div className="competency-field-row">
				  <div className="inline competency-widget-size-1">
					  <CreatableSelectLabeled
						label={{title:this.props.translate('content.tools.tool.title')}}
						onChange={this.props.handleFieldOnChangeFactory('name')}
						value={[{value:this.props.value['name'],label:this.props.value['name']}]}
						options={this.props.options['tools'].map((ele)=>{return {value:ele,label:ele}})}
						isRequired={true}
					  />
					</div>
				  </div>
				  <div className="competency-field-row flex">
				  <div className="inline expertise-widget-size">
					<SelectLabeled
						label={{title : this.props.translate("content.tools.tool-expertise.title")}}
						value={value}
						onChange={this.props.handleFieldOnChangeFactory('expertise')}
						options={options}
					/>
				  </div>
				  <div className="fill-remaining-space"/>
				  <div className="inline number-widget-size">
						<InputNumber
							onBlur={this.props.blurHandler}
							value={this.props.value['experience']}
							name={'experience'}
							isRequired={true}
							label={{ title: this.props.translate("content.intervention-level.intervention-experience.title") }}
							suffix={this.props.translate('years')}
						/>
					</div>
				</div>
			  <div className="competency-field-row">
					<TextAreaLabeled
						onBlur={this.props.blurHandler}
						name={'justification'}
						value={this.props.value['justification']}
						isRequired={true}
						label={{ title: 'justification' }}
						placeholder={this.props.translate(`content.tools.placeholder.${this.props.value['experience']}`)}
						maxLength={1000}
						height={'100px'}
					/>
				</div>
			</div>
		)
	}

}





export default withRouter((connect(mapStateToProps, mapDispatchToProps)(withLocalize(FormContainer))));